import { render, staticRenderFns } from "./side-nav-store.vue?vue&type=template&id=be447c1a&scoped=true"
import script from "./side-nav-store.vue?vue&type=script&lang=js"
export * from "./side-nav-store.vue?vue&type=script&lang=js"
import style0 from "./side-nav-store.vue?vue&type=style&index=0&id=be447c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be447c1a",
  null
  
)

export default component.exports